import { executeRequest, Request, Response } from '@jfs/network'
import { getAPIURL, getPaymentHeader } from '../config'

const responseParser = (response: Response) => {
  const { data } = response
  return data
}

export const getIntentStatus = (transactionId: string) => {
  const input = {
    transactionId: transactionId,
  }

  const publicURL = getAPIURL('intentStatus')
  const request: Request<{}> = {
    apiPath: publicURL,
    cache: false,
    method: 'POST',
    body: input,
    headers: {
      ...getPaymentHeader(),
    },
  }
  return executeRequest(request)
    .then((data) => {
      if (data?.data?.intentDetails) {
        return responseParser(data)
      } else {
        throw data
      }
    })
    .catch((err) => {
      const { data: { error = {} } = {} } = err
      throw error
    })
}
